import { ImportFileDto } from '../dtos/import-file.dto';
import { ImportFile } from '../models/import-file';

/**
 * Import file.
 * @param {ImportFile} model Import file model.
 * @returns {FormData}
 */
function toDto(model) {
  const importFileDto = new ImportFileDto({
    file: model.file,
    group_admin_id: model.groupAdminId,
  });
  const formData = new FormData();
  Object.keys(importFileDto).forEach(key => {
    formData.append(key, importFileDto[key]);
  });
  return formData;
}

/**
 * Map file data to dto.
 * @param {ImportFileDto} data File data dto.
 * @returns {ImportFile}
 */
function validationErrorFromDto(data) {
  return {
    file: data?.file,
    groupAdminId: data?.group_admin_id,
  };
}

export const importFileMapper = {
  toDto,
  validationErrorFromDto,
};
